/**
 * Simple function that takes in any string and capitalizes the first character, unbeknownst of the strings formatting.
 * @param inputString
 * @returns
 */
export const capitalizeFirstLetter = (inputString: string): string => {
  return inputString.charAt(0).toUpperCase() + inputString.slice(1);
};

/**
 * If any other form of string, than one consisting of comma seperated numbers, then this function doesn't work.
 * It won't error but give back a falsy number or NaN
 * @param input expects a comma seperated string of numbers.
 * @param decimalInput how many decimals the output should contain
 * @returns
 */
export const sumNumbersInCommaSeparatedString = (input: string, decimalInput?: number): number => {
  try {
    const decimals = decimalInput ? decimalInput : 0;
    const sum = input.split(",").reduce((prev, curr) => {
      return (prev += parseFloat(curr));
    }, 0);
    return parseFloat(sum.toFixed(decimals));
  } catch (err) {
    throw err;
  }
};
